@if (currentUser$ | async; as currentUser) {
  <lla-loud-announcements-host></lla-loud-announcements-host>
  <!-- print:block on the layout wrappers: Chrome cannot paginate content inside flex containers -->
  <div class="h-full lg:overflow-hidden flex flex-col print:block print:overflow-visible">
    <div class="print:hidden lg:hidden">
      <lla-main-header
        [mainMenuRoutes]="userMainRoutes"
        (showLargeMenuChanged)="onShowLargeMenuChange($event)"
      ></lla-main-header>
    </div>

    <div class="flex-1 flex w-full lg:overflow-auto print:block print:overflow-visible">
      <lla-main-menu
        class="print:hidden"
        [mainMenuRoutes]="userMainRoutes"
        [isCollapsed]="!showLargeMenu"
        (collapsedChanged)="onShowLargeMenuChange(!$event)"
        (showLargeMenuChanged)="onShowLargeMenuChange($event)"
      ></lla-main-menu>
      <div
        class="flex-1 flex flex-col mx-auto lg:overflow-auto beautyScroll relative print:block print:overflow-visible"
      >
        @if (isLoading) {
          <div class="absolute left-0 top-0 w-full">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        }
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
}
